var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNewStatisticIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 31.5H9C6.5145 31.5 4.5 29.4855 4.5 27V9C4.5 6.5145 6.5145 4.5 9 4.5H27C29.4855 4.5 31.5 6.5145 31.5 9V27C31.5 29.4855 29.4855 31.5 27 31.5Z",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.532 14.625H24.75V18.843",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 14.625L18.843 20.532L15.468 17.157L11.25 21.375",
    stroke: "#3378F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewStatisticIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewStatisticIcon.fdda2304.svg";
export { ForwardRef as ReactComponent };